import styled from 'styled-components';
import media from 'styled-media-query';

export const Wrapper = styled.div`
  width: 436px;

  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 100%;

    div {
      max-width: 28rem;
      main {
        max-width: 100%;
      }
    }
  }

  ${media.lessThan('small')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 100%;

    div {
      max-width: 28rem;
      main {
        max-width: 100%;
      }
    }
    `}
`;

export const DivInput = styled.div`
  display: grid;
  grid-template-columns: 252px 156px;
  width: 436px;
  grid-gap: 28px;
  grid-row-gap: 20px;
  ${media.lessThan('large')`
    height: auto;
    grid-template-columns: 1.5fr 1fr;
    grid-gap: 2rem;
  `}
  @media only screen and (max-width: 1000px) {
    height: auto;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    align-items: center;
  }
  ${media.lessThan('small')`
    height: auto;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    align-items: center;
  `}

  main {
    margin-top: 0;

    label {
      padding-left: 8px;
    }

    input {
      font-size: 14px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      padding-left: 8px;
      padding-bottom: 3px;
    }
  }
`;
